import {
    SAVE_EMPTY_CASE_SUCCESS,SAVE_EMPTY_CASE_FAILED ,SAVE_EMPTY_CASE_STARTED,
    UPDATE_EMPTY_CASE_SUCCESS,UPDATE_EMPTY_CASE_FAILED ,UPDATE_EMPTY_CASE_STARTED,
    SAVE_CASEFLOW_SUCCESS,SAVE_CASEFLOW_FAILED , SAVE_CASEFLOW_STARTED,
    UPDATE_CASEFLOW_SUCCESS,UPDATE_CASEFLOW_FAILED ,UPDATE_CASEFLOW_STARTED,
    SAVE_WORKFLOW_SUCCESS,SAVE_WORKFLOW_FAILED , SAVE_WORKFLOW_STARTED,
    UPDATE_WORKFLOW_SUCCESS,UPDATE_WORKFLOW_FAILED ,UPDATE_WORKFLOW_STARTED,
    SAVE_EMP_BIOGRAPHICS_SUCCESS,SAVE_EMP_BIOGRAPHICS_FAILED , SAVE_EMP_BIOGRAPHICS_STARTED,
    UPDATE_EMP_BIOGRAPHICS_SUCCESS,UPDATE_EMP_BIOGRAPHICS_FAILED ,UPDATE_EMP_BIOGRAPHICS_STARTED,
    SAVE_H1BFORMS_SUCCESS,SAVE_H1BFORMS_FAILED , SAVE_H1BFORMS_STARTED,
    UPDATE_H1BFORMS_SUCCESS,UPDATE_H1BFORMS_FAILED ,UPDATE_H1BFORMS_STARTED,
    GET_ALLCASEFLOW_STARTED ,GET_ALLCASEFLOW_SUCCESS, GET_ALLCASEFLOW_FAILED,
    GET_ALLCASEFLOW_BYID_STARTED ,GET_ALLCASEFLOW_BYID_SUCCESS, GET_ALLCASEFLOW_BYID_FAILED,
    GET_CASEFLOW_INITIATION_STARTED,GET_CASEFLOW_INITIATION_SUCCESS,GET_CASEFLOW_INITIATION_FAILED,
    GET_EMPLOYEE_BIOG_STARTED,GET_EMPLOYEE_BIOG_SUCCESS,GET_EMPLOYEE_BIOG_FAILED,
    GET_H1BFORMS_STARTED,GET_H1BFORMS_SUCCESS,GET_H1BFORMS_FAILED,
    SAVEPDF_H1BFORMS_STARTED, SAVEPDF_H1BFORMS_SUCCESS,SAVEPDF_H1BFORMS_FAILED,
    UPLOADFILE_H1BFORMS_STARTED, UPLOADFILE_H1BFORMS_SUCCESS,UPLOADFILE_H1BFORMS_FAILED,
    UPLOADFILE_CASEFLOW_STARTED, UPLOADFILE_CASEFLOW_SUCCESS,UPLOADFILE_CASEFLOW_FAILED,
    GET_CASEID_STARTED,GET_CASEID_SUCCESS,GET_CASEID_FAILED,
    GET_CASEDETAILS_SUCCESS,GET_CASEDETAILS_FAILED,GET_CASEDETAILS_STARTED,

    GET_ATTORNEYG28DETAILS_SUCCESS,GET_ATTORNEYG28DETAILS_FAILED,GET_ATTORNEYG28DETAILS_STARTED,
    SAVE_ATTORNEYG28DETAILS_SUCCESS,SAVE_ATTORNEYG28DETAILS_FAILED,SAVE_ATTORNEYG28DETAILS_STARTED,
    CREATE_H1BG28FORMS_SUCCESS,CREATE_H1BG28FORMS_FAILED,CREATE_H1BG28FORMS_STARTED,
    

    SAVE_I907FORM_SUCCESS,SAVE_I907FORM_FAILED , SAVE_I907FORM_STARTED,
    UPDATE_I907FORM_SUCCESS,UPDATE_I907FORM_FAILED ,UPDATE_I907FORM_STARTED,
    GET_I907FORM_STARTED ,GET_I907FORM_SUCCESS, GET_I907FORM_FAILED,
   
    CREATE_I907FORMS_STARTED, CREATE_I907FORMS_SUCCESS,CREATE_I907FORMS_FAILED,
    GET_EMPLOYER_LIST_STARTED ,GET_EMPLOYER_LIST_SUCCESS, GET_EMPLOYER_LIST_FAILED,
    GET_PETITION_APPROVED_STARTED,GET_PETITION_APPROVED_SUCCESS,GET_PETITION_APPROVED_FAILED,
    CREATE_EMPLOYEMENT_STARTED,CREATE_EMPLOYEMENT_SUCCESS,CREATE_EMPLOYEMENT_FAILED,
    UPDATE_EMPLOYEMENT_STARTED,UPDATE_EMPLOYEMENT_SUCCESS,UPDATE_EMPLOYEMENT_FAILED,

    UPDATE_ALLEMPLOYEMENT_STARTED,UPDATE_ALLEMPLOYEMENT_SUCCESS,UPDATE_ALLEMPLOYEMENT_FAILED,

    GET_PLAN_ALLCASEFLOW_STARTED,GET_PLAN_ALLCASEFLOW_SUCCESS,GET_PLAN_ALLCASEFLOW_FAILED

  } from '../actions/VisaCareCase';

  
const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const visaCareEmptyCaseData = (state = intialData, action: any) => {

  switch (action.type) {
      case SAVE_EMPTY_CASE_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_EMPTY_CASE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_EMPTY_CASE_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
  default:
        return state;
    }
    
}  
export const visaCareCaseData = (state = intialData, action: any) => {

    switch (action.type) {
      
      case UPDATE_EMPTY_CASE_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case UPDATE_EMPTY_CASE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_EMPTY_CASE_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case SAVE_CASEFLOW_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SAVE_CASEFLOW_SUCCESS:
      if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
        action.payload="Error Occurs in Input. Pls try Again...";
        alert("Error Occurs in Input. Pls try Again...");
      } 
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_CASEFLOW_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case UPDATE_CASEFLOW_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case UPDATE_CASEFLOW_SUCCESS:
      if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
        action.payload="Error Occurs in Input. Pls try Again...";
        alert("Error Occurs in Input. Pls try Again...");
      } 
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_CASEFLOW_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case SAVE_WORKFLOW_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SAVE_WORKFLOW_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_WORKFLOW_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case UPDATE_WORKFLOW_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case UPDATE_WORKFLOW_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_WORKFLOW_FAILED:
      return {
        ...state,
        isLoading: true,
      };
     
     
      case GET_ALLCASEFLOW_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_ALLCASEFLOW_SUCCESS:
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_ALLCASEFLOW_FAILED:
     return {
       ...state,
       isLoading: true,
     };
     case GET_ALLCASEFLOW_BYID_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_ALLCASEFLOW_BYID_SUCCESS:
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_ALLCASEFLOW_BYID_FAILED:
     return {
       ...state,
       isLoading: true,
     };
     case GET_CASEFLOW_INITIATION_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_CASEFLOW_INITIATION_SUCCESS:
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_CASEFLOW_INITIATION_FAILED:
     return {
       ...state,
       isLoading: true,
     };
      default:
        return state;
    }
    
}  
export const visaCareCaseIdData = (state = intialData, action: any) => {
  switch (action.type) {
  case GET_CASEID_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case GET_CASEID_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case GET_CASEID_FAILED:
  return {
    ...state,
    isLoading: true,
  };
  default:
    return state;
}
}
export const h1bFormPdfData = (state = intialData, action: any) => {

  switch (action.type) {
    case SAVEPDF_H1BFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVEPDF_H1BFORMS_SUCCESS:
      return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVEPDF_H1BFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
        return state;
    }
    
}
export const visaCareH1BFormData = (state = intialData, action: any) => {
  switch (action.type) {
    case SAVE_H1BFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_H1BFORMS_SUCCESS:
    if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    } 
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_H1BFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case UPDATE_H1BFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_H1BFORMS_SUCCESS: 
    if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    } 
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_H1BFORMS_FAILED:
    return {
      ...state,
      isLoading: true 
    };
    case GET_H1BFORMS_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_H1BFORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_H1BFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    default:
        return state;
    }
    
}
export const visaCareEmployeeBiogData = (state = intialData, action: any) => {
  switch (action.type) {
    case SAVE_EMP_BIOGRAPHICS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_EMP_BIOGRAPHICS_SUCCESS:
    if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again..."; 
      alert("Error Occurs in Input. Pls try Again...");
    } 
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_EMP_BIOGRAPHICS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case UPDATE_EMP_BIOGRAPHICS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_EMP_BIOGRAPHICS_SUCCESS:
    if(action.payload.id===undefined || action.payload.id==="" || action.payload.id===null){
      action.payload="Error Occurs in Input. Pls try Again...";
      alert("Error Occurs in Input. Pls try Again...");
    }
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_EMP_BIOGRAPHICS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_EMPLOYEE_BIOG_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_EMPLOYEE_BIOG_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_EMPLOYEE_BIOG_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    default:
      return state;
  
  }
}

export const uploadFileCaseFlowData = (state = intialData, action: any) => {
  switch (action.type) {
    case UPLOADFILE_CASEFLOW_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPLOADFILE_CASEFLOW_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPLOADFILE_CASEFLOW_FAILED:
    return {
      ...state,
      isLoading: true,
    };
 default:
      return state;
      
  }
}
export const uploadFileH1BFormsData = (state = intialData, action: any) => {
  switch (action.type) {
    case UPLOADFILE_H1BFORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPLOADFILE_H1BFORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPLOADFILE_H1BFORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
 default:
      return state;
      
  }
}

export const visaCareH1BCaseIdAllData = (state = intialData, action: any) => {
  switch (action.type) {
  case GET_CASEDETAILS_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case GET_CASEDETAILS_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case GET_CASEDETAILS_FAILED:
  return {
    ...state,
    isLoading: true,
  };
  default:
    return state;
}
}
export const attorneyG28Data = (state = intialData, action: any) => {
  switch (action.type) {
  case GET_ATTORNEYG28DETAILS_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case GET_ATTORNEYG28DETAILS_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case GET_ATTORNEYG28DETAILS_FAILED:
  return {
    ...state,
    isLoading: true,
  };
  case SAVE_ATTORNEYG28DETAILS_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case SAVE_ATTORNEYG28DETAILS_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case SAVE_ATTORNEYG28DETAILS_FAILED:
  return {
    ...state,
    isLoading: true,
  };
  default:
    return state;
}
}

export const G28PdfData = (state = intialData, action: any) => {
  switch (action.type) {
  case CREATE_H1BG28FORMS_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case CREATE_H1BG28FORMS_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case CREATE_H1BG28FORMS_FAILED:
  return {
    ...state,
    isLoading: true,
  };
  default:
    return state;
}
}

export const I907FormData = (state = intialData, action: any) => {
 
  switch (action.type) {
    case SAVE_I907FORM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_I907FORM_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_I907FORM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case UPDATE_I907FORM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_I907FORM_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_I907FORM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_I907FORM_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_I907FORM_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_I907FORM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
   
    
    default:
      return state;
  
  }
}
export const I907PdfData = (state = intialData, action: any) => {
  switch (action.type) {
    case CREATE_I907FORMS_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case CREATE_I907FORMS_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case CREATE_I907FORMS_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
      return state;
  
  }
}
export const visaCareEmployerListData = (state = intialData, action: any) => {
  switch (action.type) {
  case GET_EMPLOYER_LIST_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case GET_EMPLOYER_LIST_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case GET_EMPLOYER_LIST_FAILED:
  return {
    ...state,
    isLoading: true,
  };
  default:
    return state;
}
}

export const petitionApprovedData = (state = intialData, action: any) => {
  switch (action.type) {
  case GET_PETITION_APPROVED_STARTED:  
  return {
    ...state,
    items:[],
    isLoading: true,
  };
case GET_PETITION_APPROVED_SUCCESS:
  return {
    ...state,
    isLoading: false,
    status: action.status,
    items: action.payload
  };
case GET_PETITION_APPROVED_FAILED:
  return {
    ...state,
    isLoading: true,
    status:"Fail"
  };
  default:
    return state;
}
}

export const employementData = (state = intialData, action: any) => {
  switch (action.type) {   
    case UPDATE_EMPLOYEMENT_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_EMPLOYEMENT_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_EMPLOYEMENT_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
    case CREATE_EMPLOYEMENT_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case CREATE_EMPLOYEMENT_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case CREATE_EMPLOYEMENT_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    
    default:
      return state;
  
  }
}

export const employementAllData = (state = intialData, action: any) => {
  switch (action.type) {   
    case UPDATE_ALLEMPLOYEMENT_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_ALLEMPLOYEMENT_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_ALLEMPLOYEMENT_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
    
    default:
      return state;
  
  }
}

export const visaCareAttorneyHelpCaseData = (state = intialData, action: any) => {
  switch (action.type) {   
    case GET_PLAN_ALLCASEFLOW_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_PLAN_ALLCASEFLOW_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_PLAN_ALLCASEFLOW_FAILED:
    return {
      ...state,
      isLoading: true,
    };  
    
    default:
      return state;
  
  }
}



